const ShippingCarriers = () => import("Core/companies/shipping_carriers/views/ShippingCarriers");
const ShippingCarriersForm = () => import("Core/companies/shipping_carriers/views/ShippingCarriersForm");
const ShippingCarrierProfile = () => import("Core/companies/shipping_carriers/views/ShippingCarrierProfile");

export default {
    children: [
        {
            path: "configuration/shipping_carriers",
            name: "shipping_carriers",
            component: ShippingCarriers,
            meta: {
                requiresAuth: true,
                title: "lang.shipping_carriers",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
        {
            path: "configuration/shipping_carrier/:id(\\d+)?/:tab?",
            name: "shipping_carrier",
            component: ShippingCarrierProfile,
            meta: {
                requiresAuth: true,
                title: "lang.shipping_carriers",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["configuration.read"],
            },
        },
    ],
};
